/**
 * sl-9qm.9: SeoConfig Zod Schema
 *
 * Validation schema for SEO configuration.
 * Canonical URL is validated to be HTTPS only (no javascript: or data:).
 */
import { FormulaSchema } from '@streamlain/view-config';
import { z } from 'zod';

export const seoConfigSchema = z.object({
  titleTemplate: z.string().max(200),
  titleFormula: FormulaSchema.nullable().optional(),
  defaultTitle: z.string().min(1).max(100),
  description: z.string().max(500),
  descriptionTemplate: z.string().max(300).optional(),
  descriptionFormula: FormulaSchema.nullable().optional(),
  keywords: z.array(z.string().max(50)).max(20),
  author: z.string().max(100),
  ogImage: z.string().optional(),
  ogImageTemplate: z.string().optional(),
  ogImageFormula: FormulaSchema.nullable().optional(),
  ogType: z.enum(['website', 'article']),
  indexing: z.boolean(),
  canonicalUrl: z
    .string()
    .url()
    .refine(url => url.startsWith('https://'), {
      message: 'Canonical URL must use HTTPS',
    })
    .optional(),
  structuredDataType: z.enum([
    'Article',
    'Breadcrumb',
    'FAQ',
    'Organization',
    'none',
  ]),
});
